export default __webpack_public_path__ + "static/media/Aubusson-Blue.20a876e9.jpg";